import { TalentEnablementUI } from "features";

const TalentEnablement = () => {
  return (
    <>
      <TalentEnablementUI />
    </>
  );
};

export { TalentEnablement };
